export default "__VITE_PUBLIC_ASSET__b8ed302e__"